<template>
	<div>
		<a style="visibility: hidden;" @click="drawGraph()">refresh</a>
		<div class="graph-container">
			<div ref="chart" class="chart"></div>
		</div>
	</div>
</template>

<script>
import echarts from "echarts";
import { EventBus } from "../../../eventBus.js";

export default {
	name: "DayForecastGraph",
	props: {
		graphData: {
			type: Array,
			default: () => []
		},
		graphLabel: {
			type: Array,
			default: () => ["Last Year", "Last Week", "Current Trend", "Forecast"]
		}
	},
	created() {
		// this.$store.commit('SalesForecastStore/SET_FORECAST_APPROVE_GRAPH_DATA')
		// console.log('created')
	},
	mounted() {
		// console.log('mounted')
		this.drawGraph();
		// setTimeout(()=>{
		//     this.drawGraph();
		// }, 1500);
		EventBus.$on("renderDayForecastGraph", item => {
			this.drawGraph();
			console.log("Event fired");
		});
	},
	beforeDestroy() {
		EventBus.$off("renderDayForecastGraph");
	},
	methods: {
		drawGraph() {
			const chart = echarts.init(this.$refs.chart);
			// this.$store.commit('SalesForecastStore/SET_FORECAST_APPROVE_GRAPH_DATA')
			const option = {
				xAxis: {
					type: "category",
					data: this.graphLabel,
					boundaryGap: false
				},
				yAxis: [
					{
						type: "value"
					},
					{
						type: "value",
						axisLine: {
							show: true, // Show the line at the right side of the y-axis
							lineStyle: {
								color: "black" // Customize the color of the line
							}
						}
					}
				],
				series: [
					{
                type: "line",
                data: this.graphData,
                color: "#D26300",
                symbol: 'circle',
                symbolSize: 10,
				tooltip: {
					trigger: "axis",
					show: false
				},
                label: {
                    show: true,
                    position: 'top',
                    formatter: function(params) {
                        // Customize formatting with different text color and font weight for {c}
                        return params.name + ': ' + '{c|' + params.value + '}';
                    },
					rich: {
                        c: {
                            color: '#fff',
                            fontWeight: 'bold',
							fontSize: 15
                        }
                    },
                    backgroundColor: 'rgba(50, 50, 50, 0.7)', // Set background color of label
					fontSize: 15, // Set font size of label
                    color: 'white', // Set text color of label
                    padding: [15, 10], // Add padding to the label
					borderRadius: 5, // Set border radius of label
                }
            }
				]
			};

			chart.setOption(option);
		}
	}
};
</script>

<style scoped>
.graph-container {
	width: 100%;
	height: 400px;
}

.chart {
	width: 100%;
	height: 100%;
}
</style>
